import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Icon from 'components/AppIcon';
import NavigationBar from 'components/ui/NavigationBar';
import Footer from 'components/ui/Footer';
import LogoLoader3D from 'components/ui/LogoLoader3D';
import HeroSection from './landing-page/components/HeroSection';
import SuccessMetrics from './landing-page/components/SuccessMetrics';
import InteractiveGlobe from './landing-page/components/InteractiveGlobe';
import ProblemSolution from './landing-page/components/ProblemSolution';
import TrustBadges from './landing-page/components/TrustBadges';
import CompanyCredentials from './landing-page/components/CompanyCredentials';

const HomePage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userLocation, setUserLocation] = useState('Global');

  useEffect(() => {
    // Simulate loading time for 3D assets
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // Detect user location (mock implementation)
    const detectLocation = () => {
      const locations = ['United States', 'United Kingdom', 'Germany', 'France', 'Canada', 'Australia'];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setUserLocation(randomLocation);
    };

    detectLocation();

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (isLoading) {
    return <LogoLoader3D />;
  }

  return (
    <div className="min-h-screen gradient-background-main">
      {/* Navigation Bar */}
      <NavigationBar />
      
      {/* Hero Section */}
      <HeroSection userLocation={userLocation} />

      {/* About Section - Integrated into Home Page */}
      <section id="about" className="py-16 sm:py-24 lg:py-32">
        {/* Section Header */}
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center mb-12 sm:mb-16 lg:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="heading-lg text-text-primary mb-4 sm:mb-6">
              About Exquisite Coral Africa
            </h2>
            <p className="body-lg text-text-secondary max-w-4xl mx-auto">
              Your trusted partner in African export excellence, connecting premium products 
              with global markets through unmatched quality and reliability.
            </p>
          </motion.div>
        </div>

        {/* Success Metrics */}
        <SuccessMetrics />

        {/* Interactive Globe with Success Stories */}
        <InteractiveGlobe />

        {/* Problem & Solution */}
        <ProblemSolution />

        {/* Trust Badges */}
        <TrustBadges />

        {/* Company Credentials */}
        <CompanyCredentials />
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HomePage; 